import React, { ReactNode } from "react";
import Placeholder from "../../../../../components/placeholder/placeholder";
import NexarOneDevice from "../../../../../core/assets/nexar-one-device.png";
import Beam2Device from "../../../../../core/assets/beam-2-device.svg";
import Beam2MiniDevice from "../../../../../core/assets/beam-2-mini-device.png";
import styles from "./camera-list-item.module.scss";
import Event from "../../../../../core/consts/analytics-events";
import { useDI } from "../../../../../core/di";
import { Subscription } from "../../../../../contracts/nexar-api/types";

interface Props {
  title: string;
  trialEndDate?: Date;
  isPlaceholder?: boolean;
  description: string;
  subscription?: Subscription;
}

const getCameraIcon = (title: string)=>{
  if (title.toLowerCase().startsWith("b2")){
    return Beam2Device
  }
  if (title.toLowerCase().startsWith("b0")){
    return Beam2MiniDevice
  }
  return NexarOneDevice

}

export function CameraListItem(props: Props) {
  const { title, trialEndDate, isPlaceholder, description } = props;
  const { analytics } = useDI();

  const handleIconClick = () => {
    analytics?.track(Event.ConnectCameraClicked);
  };
  const isInApp = !!sessionStorage.getItem('app')
  const icon = getCameraIcon(title)

  return (
    <div className={styles.CameraListItemWrapper}>
      <Placeholder ready={!isPlaceholder}>
        <div className={styles.Left}>
          <img
            alt="nexar-one-device"
            src={icon}
            width={64}
            height={64}
            onClick={handleIconClick}
          />
        </div>
      </Placeholder>
      <div className={styles.Right}>
        <Placeholder ready={!isPlaceholder}>
          <p className={styles.Title}>{title}</p>
          {!isInApp &&<p className={styles.Text}>{description}</p>}
        </Placeholder>
      </div>
    </div>
  );
}

export default CameraListItem;
